export default __webpack_public_path__ + "static/113-min-min-9de42e0ef82c026338a796c1c662645a.jpg";